import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footer from "../../components/footer/Footer";
import Imagewheel from "../../components/imagewheel/Imagewheel";
import Newsletter from "../../components/newsletter/Newsletter";
import {
  ContactFormButton,
  ContactContainer,
  ContactEmergencyBottomTitle,
  ContactEmergencyContainer,
  ContactEmergencyDescription,
  ContactEmergencySection,
  ContactEmergencyTitle,
  ContactEmergencyWrapper,
  ContactForm,
  ContactFormContainer,
  ContactFormGradientOverlay,
  ContactFormImage,
  ContactFormTextContainer,
  ContactFormTextIntroTitle,
  ContactFormTextSection,
  ContactFormTextSectionLocation,
  ContactFormTextSectionMail,
  ContactFormTextSectionText,
  ContactFormTextSectionTitle,
  ContactFormTextSectionWrapper,
  ContactFormTextText,
  ContactFormTextTitle,
  ContactFormWrapper,
  ContactOpeningHours,
  ContactOpeningHoursContainer,
  ContactOpeningHoursIcon,
  ContactOpeningHoursSection,
  ContactOpeningHoursTitle,
  ContactPageContainer,
  ContactTextContainer,
  ContactTextContainerIntroTitle,
  ContactTextContainerText,
  ContactTextContainerTitle,
  ContactFormInput,
  ContactFormInputRow,
  ContactFormTextArea,
  ContactFormLabel,
  ContactFormMap,
} from "./ContactStyles";
import {
  faCheck,
  faClock,
  faClockRotateLeft,
  faLocationDot,
  faMailBulk,
  faSpinner,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { smartAPI } from "../../components/api/Smart";

function Contact() {
  const images = ["/assets/12.jpg", "/assets/13.jpg", "/assets/14.jpg"];
  const [data, setData] = useState({
    name: "",
    phone: "",
    mail: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Handle input changes
  function handleChange(e) {
    setData({ ...data, [e.target.id]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await smartAPI(data, "POST", "contact");

      if (response.status === 200) {
        setMessage("Bedankt! Je bericht is verzonden.");
        setData({
          name: "",
          phone: "",
          mail: "",
          subject: "",
          message: "",
        });
      } else {
        setMessage("Er is iets misgegaan, probeer het opnieuw.");
      }
    } catch (error) {
      setMessage("Fout bij het verzenden, probeer later opnieuw.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <ContactPageContainer>
      {/* Contact: Imagewheel */}
      <Imagewheel images={images} isContact={true} />

      <ContactContainer>
        <ContactTextContainer>
          <ContactTextContainerTitle>Neem contact op</ContactTextContainerTitle>
          <ContactTextContainerIntroTitle>
            Hoe kunnen wij je helpen?
          </ContactTextContainerIntroTitle>
          <ContactTextContainerText>
            Heb je een vraag of wens je meer informatie? Vul het onderstaande
            formulier in of neem telefonisch contact met ons op tijdens
            kantooruren. Ons team staat klaar om je verder te helpen!
          </ContactTextContainerText>
        </ContactTextContainer>

        <ContactOpeningHoursContainer>
          <ContactOpeningHoursSection>
            <ContactOpeningHoursIcon icon={faClock} />
          </ContactOpeningHoursSection>
          <ContactOpeningHoursTitle>Openingstijden</ContactOpeningHoursTitle>
          <ContactOpeningHours>
            <div style={{ fontWeight: "bold" }}>Maandag - Vrijdag</div>
            <div>(09.00 - 17.00)</div>
          </ContactOpeningHours>
        </ContactOpeningHoursContainer>

        <ContactEmergencyContainer>
          <ContactEmergencyTitle>Spoed?</ContactEmergencyTitle>
          <ContactEmergencyWrapper>
            <ContactEmergencySection>
              <FontAwesomeIcon
                icon={faClockRotateLeft}
                style={{ fontSize: "16px", color: "#3393F0" }}
              />
            </ContactEmergencySection>
            <ContactEmergencyDescription>
              <div style={{ fontWeight: "bold" }}>24 uur per dag</div>
              <div>Alleen voor spoed aanvragen</div>
            </ContactEmergencyDescription>
          </ContactEmergencyWrapper>
          <ContactEmergencyBottomTitle>
            <a
              href="tel:+31850607774"
              style={{ textDecoration: "none", color: "white" }}
            >
              +31850607774
            </a>
          </ContactEmergencyBottomTitle>
        </ContactEmergencyContainer>
      </ContactContainer>

      <ContactFormContainer>
        <ContactFormImage src="/assets/20.jpg" alt="Smart Personeel" />
        <ContactFormGradientOverlay />

        <ContactFormWrapper>
          <ContactFormTextContainer>
            <ContactFormTextIntroTitle>Bezoekadres</ContactFormTextIntroTitle>
            <ContactFormTextTitle>
              Kom vrijblijvend bij ons langs of maak een afspraak.
            </ContactFormTextTitle>
            <ContactFormTextText>
              Wij zijn er voor je, en de koffie staat altijd klaar!
            </ContactFormTextText>
            <ContactFormTextSectionWrapper>
              <a
                href="https://www.google.com/maps?q=Kerkenbos+1307C,+6546+BG+Nijmegen"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <ContactFormTextSectionLocation>
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    style={{ fontSize: "20px", color: "#3393F0" }}
                  />
                  <ContactFormTextSection>
                    <ContactFormTextSectionTitle>
                      Locatie
                    </ContactFormTextSectionTitle>
                    <ContactFormTextSectionText>
                      Kerkenbos 1307C <br /> 6546 BG Nijmegen
                    </ContactFormTextSectionText>
                  </ContactFormTextSection>
                </ContactFormTextSectionLocation>
              </a>

              <ContactFormTextSectionMail>
                <FontAwesomeIcon
                  icon={faMailBulk}
                  style={{ fontSize: "20px", color: "#3393F0" }}
                />
                <ContactFormTextSection>
                  <ContactFormTextSectionTitle>
                    Mail ons!
                  </ContactFormTextSectionTitle>
                  <ContactFormTextSectionText>
                    <a
                      href="mailto:info@smart-personeel.nl"
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      info@smart-personeel.nl
                    </a>
                  </ContactFormTextSectionText>
                </ContactFormTextSection>
              </ContactFormTextSectionMail>
            </ContactFormTextSectionWrapper>
          </ContactFormTextContainer>

          <ContactForm onSubmit={handleSubmit}>
            <ContactFormInputRow style={{ marginBottom: "20px" }}>
              <div style={{ flex: 1 }}>
                <ContactFormLabel htmlFor="name">Naam</ContactFormLabel>
                <ContactFormInput
                  id="name"
                  type="text"
                  placeholder="Naam"
                  value={data.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div style={{ flex: 1 }}>
                <ContactFormLabel htmlFor="phone">Telefoon</ContactFormLabel>
                <ContactFormInput
                  id="phone"
                  type="tel"
                  placeholder="Telefoon"
                  value={data.phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </ContactFormInputRow>

            <div style={{ marginBottom: "20px" }}>
              <ContactFormLabel htmlFor="mail">Email</ContactFormLabel>
              <ContactFormInput
                id="mail"
                type="email"
                placeholder="Email"
                value={data.mail}
                onChange={handleChange}
                required
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <ContactFormLabel htmlFor="subject">Onderwerp</ContactFormLabel>
              <ContactFormInput
                id="subject"
                type="text"
                placeholder="Onderwerp"
                value={data.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <ContactFormLabel htmlFor="message">Bericht</ContactFormLabel>
              <ContactFormTextArea
                id="message"
                placeholder="Bericht"
                value={data.message}
                onChange={handleChange}
                required
              />
            </div>
            {message.includes("Bedankt") ? (
              <p
                style={{
                  marginTop: "20px",
                  color: "#17224d",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                <FontAwesomeIcon
                  icon={faCheck}
                  style={{ color: "green", marginRight: "15px" }}
                />
                {message}
              </p>
            ) : (
              <>
                <ContactFormButton type="submit" disabled={loading}>
                  {loading ? (
                    <FontAwesomeIcon icon={faSpinner} spin />
                  ) : (
                    "Verzenden"
                  )}
                </ContactFormButton>
                {message && (
                  <p
                    style={{
                      marginTop: "20px",
                      color: "#17224d",
                      fontSize: "14px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faWarning}
                      style={{ marginRight: "15px" }}
                    />{" "}
                    {message}
                  </p>
                )}
              </>
            )}
          </ContactForm>
        </ContactFormWrapper>
      </ContactFormContainer>
      <ContactFormMap
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2436.0733068352074!2d5.852847016098213!3d51.83487735006924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c6cd1b18ff5c87%3A0x292c20212f2b2424!2sKerkenbos%201307C%2C%206546%20BG%20Nijmegen!5e0!3m2!1sen!2snl!4v1615377119289!5m2!1sen!2snl"
        allowFullScreen=""
        title="Smart Personeel"
      />

      {/* Contact: Newsletter */}
      <Newsletter />

      {/* Contact: Footer */}
      <Footer />
    </ContactPageContainer>
  );
}

export default Contact;
